import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import { ITareaTomarLiberarPost } from "../../../interfaces/backendApi/tareaTomarLiberar";
import {
  BackendTareaTomarLiberar,
  getCurrentDomain,
} from "../../../apis/backend/Api";
import mock_json from "../../../dataJson/tomarLiberar.json";
import { formatearMensajeBackend } from "../../../apis/helper/helperApi";
import { TypeStatus } from "../../helpers/constantes";
interface State {
  tareaTomarLiberarBackend: any[];
  status: TypeStatus;
  isLoading: boolean;
  Success: boolean;
  Mensaje: string | null;
  error: string | null;
  assigned_id: string;
}

const initialState: State = {
  tareaTomarLiberarBackend: [],
  status: "idle",
  isLoading: false,
  Success: false,
  Mensaje: "",
  error: null,
  assigned_id: "",
};

export interface defaultResponse {
  data: any;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}
interface AxiosResponseCustom<T = any, D = any> extends Omit<
  AxiosResponse<T, D>,
  "config"
> {
  Success: boolean;
  Mensaje: string;
}

const defaultResp: defaultResponse = {
  data: undefined,
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};

export const defaultResps: defaultResponse = {
  data: [],
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};

const tareaTomarLiberarSlice = createSlice({
  name: "tareaTomarLiberarBackend",
  initialState,
  reducers: {
    setTareaTomarLiberarBackend: (state, action: PayloadAction<any[]>) => {
      state.tareaTomarLiberarBackend = action.payload;
    },
    getTareaTomarLiberarBackend: (state, action: PayloadAction<any[]>) => {
      state.tareaTomarLiberarBackend = action.payload;
    },
    setClearTareaTomarLiberarBackend: (state, action: PayloadAction<any[]>) => {
      state = initialState;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setResult: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
    setAssigned_id: (state, action: PayloadAction<string>) => {
      state.assigned_id = action.payload;
    },
  },
});

export const setBackendTareaTomarLiberar =
  (iTareaTomarLiberarPost: ITareaTomarLiberarPost): Thunk =>
    async (dispatch): Promise<AxiosResponse | AxiosError> => {
      dispatch(setIsLoading(true));
      const esTomarLiberar =
        iTareaTomarLiberarPost.assigned_id === "1" ? "Tomar" : "Liberar";
      try {
        let response: AxiosResponse = await BackendTareaTomarLiberar(
          iTareaTomarLiberarPost,
        );

        const isError =
          response.data?.Success === false ||
          (response.data?.ResultadoSolicitud !== undefined &&
            response.data?.ResultadoSolicitud !== 200);

        if (isError) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
          response.status = 0;
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                response.data.Mensaje !== ""
                  ? response.data.Mensaje
                  : "Fallo " + esTomarLiberar + " la tarea ",
              ),
            ),
          );
        } else {
          dispatch(setTareaTomarLiberarBackend(response.data.Data));
          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
          response.status = 1;
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                response.data.Mensaje !== ""
                  ? response.data.Mensaje
                  : esTomarLiberar + " fue exitoso",
              ),
            ),
          );
        }
        dispatch(setAssigned_id(iTareaTomarLiberarPost.assigned_id));
        return response.data;
      } catch (error: any) {
        dispatch(setIsLoading(false));
        dispatch(setSuccess(false));
        dispatch(setStatus("failed"));

        if (error.response?.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        } else if (error.response) {
          // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
          console.error(
            "Error de servidor:",
            error.response.status,
            error.response.data,
          );

          const errorData = error.response.data;
          const mensajeBackend = errorData?.Mensaje;
          const resultadoSolicitud = errorData?.ResultadoSolicitud;

          // Si el backend devolvió un objeto de respuesta con ResultadoSolicitud !== 200 o Success === false
          if (
            mensajeBackend &&
            (resultadoSolicitud !== 200 || errorData?.Success === false)
          ) {
            dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
          } else {
            dispatch(
              setMensaje(
                `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
              ),
            );
          }
        } else if (error.request) {
          // La solicitud fue enviada, pero no hubo respuesta
          console.error("Error de conexión:", error.message);
          dispatch(
            setMensaje(
              "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
            ),
          );
        } else {
          // Es un error de red (DNS, etc.) o un error de configuración de la solicitud
          console.error("Error de red o solicitud:", error.message);
          dispatch(
            setMensaje(
              "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
            ),
          );
        }
        return error as AxiosError;
      } finally {
        dispatch(setIsLoading(false));
        if (getCurrentDomain() === "localhost") {
          dispatch(setIsLoading(true));
          let response = defaultResp;
          response.data = mock_json;

          const isErrorMock =
            response.data?.Success === false ||
            (response.data?.ResultadoSolicitud !== undefined &&
              response.data?.ResultadoSolicitud !== 200);

          if (isErrorMock) {
            dispatch(setIsLoading(false));
            dispatch(setStatus("failed"));
            dispatch(setSuccess(false));
            response.status = 0;
            dispatch(
              setMensaje(
                formatearMensajeBackend(
                  response.data.Mensaje !== ""
                    ? response.data.Mensaje + ' perros acaa '
                    : "Fallo " + esTomarLiberar + " la tarea ",
                ),
              ),
            );
          } else {
            dispatch(setTareaTomarLiberarBackend(response.data.Data));
            dispatch(setIsLoading(false));
            dispatch(setStatus("succeeded"));
            dispatch(setSuccess(true));
            response.status = 1;
            dispatch(
              setMensaje(
                formatearMensajeBackend(
                  response.data.Mensaje !== ""
                    ? response.data.Mensaje
                    : esTomarLiberar + " fue  exitoso",
                ),
              ),
            );
          }
          dispatch(setAssigned_id(iTareaTomarLiberarPost.assigned_id));
        }
      }
    };

export const setBackendClearTareaTomarLiberar =
  (): Thunk =>
    async (dispatch): Promise<AxiosResponse | AxiosError> => {
      dispatch(setIsLoading(true));
      try {
        let response = defaultResp;
        dispatch(setTareaTomarLiberarBackend([]));
        dispatch(setIsLoading(false));
        dispatch(setStatus("idle"));
        dispatch(setSuccess(false));
        dispatch(setAssigned_id(""));
        dispatch(setMensaje(""));
        return response.data;
      } catch (error: any) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("failed"));
        dispatch(setSuccess(false));
        dispatch(setAssigned_id(""));
        dispatch(setMensaje(""));
        return error as AxiosError;
      } finally {
        dispatch(setIsLoading(false));
      }
    };

export const {
  setTareaTomarLiberarBackend,
  getTareaTomarLiberarBackend,
  setClearTareaTomarLiberarBackend,
  setIsLoading,
  setStatus,
  setResult,
  setSuccess,
  setMensaje,
  setAssigned_id,
} = tareaTomarLiberarSlice.actions;

export default tareaTomarLiberarSlice.reducer;
